/**
 * SessionLevelIdentityInfo.
 *
 * @copyright Realeyes OU. All rights reserved.
 */

export default class SessionLevelIdentityInfo {
    /**
     * Creates SessionLevelIdentityInfo instance.
     *
     * @param {string} sessionId is unique id of current user session
     * @param {string} participantId is unique id of current participant
     * @param {string} projectId is id of project which supposed to be in the session for this participant
     */
    constructor(sessionId, participantId, projectId) {
        this.sessionId = sessionId;
        this.participantId = participantId;
        this.projectId = projectId;
    }
}
